
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'

@Component
export default class SearchField extends Vue {
  @PropSync('search', { type: String }) public syncedSearch!: string
  @Prop() private searchlabel!: string
  @Prop() private disable!: boolean
}
